import React from "react";
import { useTranslation } from "react-i18next";
import {
    AlertDialog, AlertDialogAction, AlertDialogCancel,
    AlertDialogContent, AlertDialogDescription,
    AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@shadcn-in-nx/ui/alert-dialog";

function DeleteFileDialog({ open, file, onConfirm, onClose }) {
    const { t } = useTranslation();

    return (
        <AlertDialog
            open={open}
            onOpenChange={(isOpen) => {
                if (!isOpen) onClose();
            }}
        >
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle className="text-red-600">
                        {t("files.deleteDialog.title")}
                    </AlertDialogTitle>
                    <AlertDialogDescription className="pt-2">
                        {t("files.deleteDialog.description", {
                            fileName: file?.name,
                        })}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={onClose}>
                        {t("files.deleteDialog.cancel")}
                    </AlertDialogCancel>
                    <AlertDialogAction
                        onClick={onConfirm}
                        className="bg-red-600 hover:bg-red-700 focus:ring-red-600"
                    >
                        {t("files.deleteDialog.confirm")}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}

export default DeleteFileDialog;
